"use client"
import { useState, useEffect } from "react"
import { navStyles } from "./styles"

export default function Navigation({ toggleSidebar,profile }) {
  const [isOpen, setIsOpen] = useState(false)
  const [activeSection, setActiveSection] = useState("about")
  const [isLargeScreen, setIsLargeScreen] = useState(false)

  useEffect(() => {
    const checkScreenSize = () => {
      setIsLargeScreen(window.innerWidth >= 992)
    }

    checkScreenSize()
    window.addEventListener("resize", checkScreenSize)

    return () => window.removeEventListener("resize", checkScreenSize)
  }, [])

  useEffect(() => {
    const handleScroll = () => {
      const sections = ["about", "experience", "education", "skills", "interests", "awards"]

      for (const section of sections) {
        const element = document.getElementById(section)
        if (!element) continue

        const rect = element.getBoundingClientRect()
        if (rect.top <= 100 && rect.bottom >= 100) {
          setActiveSection(section)
          break
        }
      }
    }

    window.addEventListener("scroll", handleScroll)
    return () => window.removeEventListener("scroll", handleScroll)
  }, [])

  const handleNavClick = (e, sectionId) => {
    e.preventDefault()
    const section = document.getElementById(sectionId)
    if (section) {
      window.scrollTo({
        top: section.offsetTop,
        behavior: "smooth",
      })
      setActiveSection(sectionId)
      setIsOpen(false)
    }
  }

  const navStyle = {
    ...navStyles.nav,
    ...(isLargeScreen ? navStyles.navLg : {}),
  }

  const brandStyle = {
    ...navStyles.brand,
    ...(isLargeScreen ? navStyles.brandLg : {}),
  }

  return (
    <>
      {/* Always-visible sidebar toggle button */}
      <button
        onClick={toggleSidebar}
        className="fixed top-6 left-6 z-50 bg-blue-600 text-white p-4 rounded-md"
        aria-label="Toggle Sidebar"
        style={{
          backgroundColor: "#007bff",
          borderRadius: "5px",
          padding: "10px",
          color: "white",
          zIndex: 50,
          position: "fixed",
          top: 24,
          left: 24,
        }}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="h-7 w-7"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16M4 18h16" />
        </svg>
      </button>
      <nav style={navStyle} id="sideNav">
        <a href="#page-top" style={brandStyle} onClick={(e) => handleNavClick(e, "about")}>
          <span style={{ display: isLargeScreen ? "none" : "block", fontSize: "1.25rem", fontWeight: "bold" }}>
            Clarence Taylor
          </span>
          {isLargeScreen && (
            <span>
              <img style={navStyles.profileImg} src={profile?.personal_image || ""} alt="Profile" />
            </span>
          )}
          <button
            style={{ ...navStyles.toggleButton, display: isLargeScreen ? "none" : "block" }}
            onClick={(e) => {
              e.preventDefault()
              setIsOpen(!isOpen)
            }}
            aria-label="Toggle navigation"
          >
            <i className={isOpen ? "fas fa-times" : "fas fa-bars"}></i>
          </button>
        </a>

        <div style={{ display: isLargeScreen ? "block" : isOpen ? "block" : "none" }} id="navbarResponsive">
          <ul style={navStyles.navList}>
            {[
              { id: "about", label: "About" },
              { id: "experience", label: "Experience" },
              { id: "education", label: "Education" },
            ].map((item) => (
              <li key={item.id} style={navStyles.navItem}>
                <a
                  style={{
                    ...navStyles.navLink,
                    ...(activeSection === item.id ? navStyles.navLinkActive : {}),
                  }}
                  href={`#${item.id}`}
                  onClick={(e) => handleNavClick(e, item.id)}
                >
                  {item.label}
                </a>
              </li>
            ))}
          </ul>
        </div>
      </nav>
    </>
  )
}
